import brokenLinkImg from '@/assets/images/broken-link.webp';

/**
 * Dead end of the public answering flow — the token is unknown or past its
 * validity. Shared by the instrument and the survey pages, and kept on the same
 * single tone as `AnswerSubmitted`, the other way out of the flow.
 */
export default function AnswerLinkInvalid() {
    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
            <div className="w-full max-w-md p-8 text-center">
                <img
                    src={brokenLinkImg}
                    alt=""
                    // Intrinsic size, so the browser reserves the box instead of
                    // shifting the text when the art lands.
                    width={833}
                    height={1202}
                    decoding="async"
                    className="mx-auto mb-6 h-44 w-auto object-contain sm:h-52"
                />
                <h1 className="mb-2 text-2xl font-bold text-foreground">Acesso Negado</h1>
                <p className="text-muted-foreground">
                    O link que você está tentando acessar é inválido ou expirou.
                </p>
            </div>
        </div>
    );
}
